import { useEffect, useState } from "react";
import { apiJson } from "../../utils/api.js";
import { BottomSheetModal } from "./BottomSheetModal.jsx";

/**
 * Выбор менеджера для передачи клиента/сделки (список с /api/transfer/managers).
 */
export function TransferManagerSheet({ open, onClose, title, hint, onTransferred }) {
  const [managers, setManagers] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [loadError, setLoadError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSelectedId("");
    setLoadError(null);
    let cancelled = false;
    (async () => {
      try {
        const data = await apiJson("/api/transfer/managers");
        if (!cancelled) setManagers(data.items || []);
      } catch (e) {
        if (!cancelled) {
          setManagers([]);
          setLoadError(e instanceof Error ? e.message : String(e));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [open]);

  return (
    <BottomSheetModal open={open} onClose={onClose} title={title}>
      {hint ? <p className="dealAssignDealerHint">{hint}</p> : null}
      {loadError ? <div className="pill">{loadError}</div> : null}
      <form
        className="dealAssignDealerForm"
        onSubmit={async (e) => {
          e.preventDefault();
          if (!selectedId) {
            window.alert("Выберите менеджера");
            return;
          }
          setBusy(true);
          try {
            await onTransferred?.(Number(selectedId));
            onClose?.();
          } catch (err) {
            window.alert(err instanceof Error ? err.message : String(err));
          } finally {
            setBusy(false);
          }
        }}
      >
        <select
          className="input dealDealerSelect"
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
          aria-label="Менеджер"
        >
          <option value="">— Выберите —</option>
          {managers.map((m) => (
            <option key={m.id} value={m.id}>
              {m.display_name || m.code || `ID ${m.id}`}
            </option>
          ))}
        </select>
        <div className="dealTaskFormActions">
          <button type="submit" className="linkBtn dealTaskSubmitBtn" disabled={busy}>
            {busy ? "…" : "Передать"}
          </button>
        </div>
      </form>
    </BottomSheetModal>
  );
}
